import { BaseIP } from "../CommonAPI/CommonApi";

//==========AGEING REPORT======================
export const GetAgeingNoData = BaseIP +"production/ageing/getAgeingList"  //Get Ageing No Data in dropdown (GET)
export const GetAgeingReportData = BaseIP +"production/ageing/getAgeingReportData"  //Get Ageing Report Data (show in Table) (GET)
export const GetAgeingReportDataExcel = BaseIP +"reports/productionOrderReport/generateAgeingExcelReport"  //Get Ageing Report Data Excel (show in Excel) (GET) (params = ?id=250001&date=05/05/2025&startDate=05/05/2025&endDate=05/08/2025)

//==========MANUFACTURE REPORT======================
export const GetManufactureReportData = BaseIP +"production/ageing/getAgeingList"  //Get Manufacture Data
